<template>
  <div id="bom-preview-page" class="content">
    <div class="header">
      <h1>{{ pageTitle }}</h1>
    </div>
    <div class="block">
      <h2>
        <Button type="primary" id="preview-next" @click="handleDone" :disabled="(error_list.length > 0 ? true : false) || status" :loading="done"><span v-if="status">{{ $t('bom_tool.edit.upload.alreadyDone')}}</Icon></span><span v-else><Icon type="md-checkmark" v-show="!done"/> {{ $t('bom_tool.edit.upload.done')}}</Icon></span></Button>
        <Button @click="handleSave" id="preview-save" :disabled="saving || (modifiedTableRows.length > 0 ? false : true)" :loading="saving">{{ $t('form.save')}}</Button>
        <Button id="reupload-file" @click="handleReupload" v-if="bom.id"><Icon type="md-refresh"></Icon> {{ $t('bom_tool.edit.upload.reupload') }}</Button>
      </h2>

      <h3>
        {{ $t('bom_hierarchy_nested_tree_editor.heading') }}
        <Dropdown trigger="click" placement="bottom-end" id="error-panel-toggle" v-if="error_list.length > 0">
          <a href="javascript:void(0)">
              <Icon type="md-warning" /> {{ $t('bom_hierarchy_nested_tree_editor.error_panel') }}
              <Icon type="ios-arrow-down"></Icon>
          </a>
          <DropdownMenu slot="list" style="padding: 5px 10px">
              <span class="error-list-tip">{{ $t('bom_hierarchy_nested_tree_editor.error_tip_1') }}</span>
              <ul class="list">
                <li v-for="error in error_list" :key="error.row"><span>#{{ error.row }}</span>{{ error.message }}</li>
              </ul>
              <span class="error-list-tip">{{ $t('bom_hierarchy_nested_tree_editor.error_tip_2') }}</span>
          </DropdownMenu>
        </Dropdown>
      </h3>
      <!-- <BOMHierarchyNestedTreeEditor
        :rows="rows"
        :columns="columns"
        :properties="properties"
        :loading="loadingFileContents"
        :temp-storage-var="tempBomRowStorageVar"
        @on-change="handleBomHierarchyChange">
      </BOMHierarchyNestedTreeEditor> -->
      <BOMHierarchyTable
        :editedRows.sync="editedRows"
        @on-change="handleBomTableHierarchyChange"
        :rows="rows"
        :columns="columns"
        :errors="error_list"></BOMHierarchyTable>
    </div>
  </div>
</template>

<script>
import BOMHierarchyTable from './components/widgets/bom-hierarchy-table'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'BOMPreview',
  components: {
    BOMHierarchyTable
  },
  data () {
    return {
      loadingFileContents: false,
      properties: ['row_number', 'line_quantity', 'unit_name', 'part_number', 'mpn', 'brand', 'specification'],
      modifiedTableRows: [],
      editedRows: {
        normal: [],
        expand: []
      },
      saving: false,
      done: false
    }
  },
  computed: {
    ...mapGetters(['customerBomFile']),
    rows () {
      return this.customerBomFile?.rows || []
    },
    columns () {
      return this.customerBomFile?.header_mapping || {}
    },
    error_list () {
      return this.customerBomFile?.validation_errors || []
    },
    status () {
      return this.customerBomFile?.status === 'submitted'
    },
    bom () {
      return this.customerBomFile?.bom || {}
    },
    pageTitle () {
      document.title = this.$t('menu.bom.preview')
      return document.title
    }
  },
  created () {
    this.loadCustomerBomFileContents(this.$route.params.fileId)
  },
  methods: {
    ...mapActions([
      'getCustomerBomFile',
      'saveCustomerBomFile',
      'finishCustomerBomFileTree'
    ]),
    loadCustomerBomFileContents (fileId) {
      this.loadingFileContents = true
      // Get the contents of the customer BOM file stored.
      this.getCustomerBomFile(fileId).finally(() => {
        this.loadingFileContents = false
      })
    },
    saveCustomerBomHierarchyHandler (rows, editedRows) {
      return this.saveCustomerBomFile({ id: this.customerBomFile.id, rows, editedRows })
    },
    handleSave () {
      this.$nextTick(() => {
        if (this.modifiedTableRows.length > 0) {
          this.saving = true
          this.saveCustomerBomHierarchyHandler(this.modifiedTableRows, [...this.editedRows.normal, ...this.editedRows.expand]).then(resp => {
            localStorage.removeItem(this.tempStorageVar)
            this.editedRows = {
              normal: [],
              expand: []
            }
          }).finally(() => {
            this.saving = false
          })
        } else {
          this.$Message.warning(this.$t('bom_tool.edit.modify.noMod'))
        }
      })
    },
    handleDone () {
      this.done = true
      this.finishCustomerBomFileTree(this.$route.params.fileId).then(resp => {
        this.$router.replace({
          name: 'menu.bom.view',
          params: {
            bomId: resp.id
          },
          query: {
            rootBomId: resp.id
          }
        })
      }).catch(() => {
        this.done = false
      })
    },
    handleBomTableHierarchyChange (rows) {
      this.modifiedTableRows = rows
    },
    handleReupload () {
      this.$router.replace({
        name: 'menu.bom.upload',
        params: {
          bomId: this.bom.id
        },
        query: {
          rootBomId: this.bom.id
        }
      })
    }
  },
  watch: {
    status () {
      if (this.status) {
        if (this.bom?.id) {
          this.$router.replace({
            name: 'menu.bom.view',
            params: {
              bomId: this.bom.id
            },
            query: {
              rootBomId: this.bom.id
            }
          })
        }
      }
    },
    '$route.params.fileId': function (fileId) {
      this.loadCustomerBomFileContents(fileId)
    }
  }
}
</script>

<style lang="less">
#preview-save, #preview-next, #reupload-file {
  float: right;
}
#preview-save, #reupload-file {
  margin-right: 10px;
}
#bom-preview-page {
  overflow: visible;
  .bom-tool-link { float: right; }
}
#error-panel-toggle {
  float: right;
  font-size: 16px;
  font-weight: normal;
  a {
    color: #ff9900;
  }
  .ivu-dropdown-menu {
    padding: 10px 20px!important;
  }
  .ivu-select-dropdown {
    width: 520px;
  }
  .error-list-tip {
    opacity: .8;
    font-size: 14px;
    color: unset;
  }
  ul.list {
    padding: 10px 0;
    list-style-type: none;
    color: #ed4014;
    li > span {
      display: inline-block;
      padding: 0 7px;
      font-size: 12px;
      border-radius: 10px;
      background-color: #ed4014;
      color: #fff;
      vertical-align: middle;
      margin-right: 10px;
    }
  }
}
.content-wrapper, .main-layout-con.ivu-layout {
  overflow: hidden!important;
}
</style>
